export const CATEGORY_ACTION_TYPES = {
    FETCH_CATEGORIES_START: 'fetch/FETCH_CATEGORIES_START',
    FETCH_CATEGORIES_SUCCESS: 'fetch/FETCH_CATEGORIES_SUCCESS',
    FETCH_CATEGORIES_FAILED: 'fetch/FETCH_CATEGORIES_FAILED',
}